<template>
  <div style="position: relative; background-color: white">
    <el-scrollbar class="navList">
      <div
        v-for="(item,index) in navList"
        :key="index"
        class="nav-item"
        :class="{ active: item.active }"
      >
        <span @click="jumpNav(item)">{{ $t("sideMenu." + item.name) }}</span>
        <i class="nav-item_close el-icon-close" v-show="!item.active" @click="closeNav(item)">
        </i>
      </div>
    </el-scrollbar>
    <span v-if="showMore" class="moreIcon" @click="clickMoreList()">...</span>
    <div id="triangle-up" v-if="showMoreList"></div>
    <div v-if="showMoreList" class="showMoreDiv">
      <ul>
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="{ activeNav: item.active }"
        >
          <span @click="jumpNav(item)">{{ $t("sideMenu." + item.name) }}</span>
          <i
            v-if="item.type == '1'"
            @click="closeNav(item)"
            class="el-icon-close"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ElScrollbar from "@/components/qs-scrollbar"
export default {
  components:{ElScrollbar},
  data() {
    return {
      showMore: false,
      showMoreList: false,
    };
  },
  mounted() {
    this.checkNavListLength();
  },
  computed: {
    navList() {
      return this.$store.getters.historyList;
    },
  },
  watch: {
    navList() {
      //普通的watch监听
      this.$nextTick(() => {
        if (this.navList.length >= 5) {
          this.showMore = true;
        } else {
          this.showMore = false;
        }
      });
    },
  },
  methods: {
    checkNavListLength() {
      if (this.navList.length >= 5) {
        this.showMore = true;
      } else {
        this.showMore = false;
      }
    },
    closeNav(item) {
      // console.log(item);
      // return
      if(item.active){
        return 
      }
      this.$store.commit("common/REMOVE_LIST", item);
    },
    jumpNav(item) {
      let flag=false
      let routes=this.$router.getRoutes()
      routes.forEach((v)=>{
        if(item.fullPath===v.path){
          flag=true
        }
      })
      if(flag) this.$router.push(item.fullPath);
      else location.href=item.fullPath
    },
    clickMoreList() {
      this.showMoreList = !this.showMoreList;
    },
  },
};
</script>

<style lang="less" scoped>
.navList {
  background-color: white;
  white-space: nowrap;
  overflow: auto;
  font-size: 14px;
  padding: 10px 0;
  margin: 0 10px;
  .nav-item {
    display: inline-block;
    border: 1px solid #d0d0d0;
    border-radius: 5px;
    padding: 5px 20px;
    position: relative;
    cursor: pointer;
    .nav-item_close {
      position: absolute;
      transition: all 0.3s;
      right: 5px;
      display: none;
      top: 8px;
      vertical-align: middle;
    }
    & > span {
      transition: transform 0.3s;
    }
    & + .nav-item {
      margin-left: 10px;
    }
    &:hover {
      & > span {
        display: inline-block;
        transform: translateX(-5px);
      }
      .nav-item_close {
        display: inline;
      }
    }
    &.active {
      background: #343c6a;
      color: white;
    }
  }
}
.navList > .activeNav,
li.activeNav {
  // border: none;
  background-color: #343c6a;
  color: white;
  span {
    color: white;
  }
}
.moreIcon {
  display: inline-block;
  background-color: white;
  position: absolute;
  right: 0;
  top: 0;
  height: 48px;
  padding: 0 14px;
  line-height: 40px;
  cursor: pointer;
}
.showMoreDiv {
  right: 5px;
  position: fixed;
  top: 100px;
  background-color: white;
  width: 200px;
  height: 300px;
  overflow: auto;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  z-index: 10;
}
li {
  position: relative;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  cursor: pointer;
}
li > i {
  position: absolute;
  right: 20px;
  top: 12px;
  cursor: pointer;
}
#triangle-up {
  right: 25px;
  position: fixed;
  top: 91px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 16px solid white;
  z-index: 11;
}
</style>
